import { Paper, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { ActionCardFooter } from './ActionCardFooter';

type Props = {
  title: string;
  message: string;
  minimized?: boolean;
  onClick: () => void;
};

export function SteeringSuggestionCard({ title, message, minimized = false, onClick }: Props) {
  return (
    <Paper
      w={minimized ? 'auto' : 374}
      px={minimized ? 'lg' : 'xl'}
      pt={minimized ? 'xs' : 'md'}
      pb={minimized ? 'xs' : 'md'}
      radius={24}
      onClick={minimized ? undefined : onClick}
      style={{
        background: 'rgba(0, 0, 0, 0.25)',
        backdropFilter: 'blur(24px)',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        cursor: minimized ? 'default' : 'pointer',
        opacity: minimized ? 0.5 : 1,
        transition: 'all 300ms ease-in-out',
      }}
    >
      <Text
        size={minimized ? 'sm' : 'textXl'}
        fw={FONT_WEIGHTS.bold}
        c="white"
        ta={minimized ? 'center' : undefined}
        style={{ transition: 'all 300ms ease-in-out' }}
      >
        {title}
      </Text>
      <Text
        size="sm"
        c="rgba(255, 255, 255, 0.7)"
        mt="xxxs"
        style={{
          maxHeight: minimized ? 0 : 40,
          opacity: minimized ? 0 : 1,
          overflow: 'hidden',
          transition: 'max-height 300ms ease-in-out, opacity 200ms ease-in-out',
        }}
      >
        {message}
      </Text>
      {!minimized && <ActionCardFooter />}
    </Paper>
  );
}
